import { CRMS, LoginProviderType } from "@whatslly/types/LoginProviderType";

type Provider = Exclude<LoginProviderType, undefined>;

// The full set of providers a user is linked to, from the identities ledger.
export function getUserProviders(user: { identities?: { provider: Provider }[] | null }): Provider[] {
  return (user.identities ?? []).map((identity) => identity.provider);
}

// Whether the user is linked to any CRM provider (Salesforce / Microsoft Dynamics).
export function isCrmUser(user: { identities?: { provider: Provider }[] | null }): boolean {
  return getUserProviders(user).some((provider) => CRMS.has(provider));
}
